// extracted by mini-css-extract-plugin
export default {"modalHead":"styles_modalHead__3nb2w","modalContent":"styles_modalContent__wgzq6","buttons":"styles_buttons__SKosU","button":"styles_button__GQdcK"};